import React from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import Header from '../components/Header/Header';
import './AboutPage.css';

const AboutPage = () => {
  const { currentLanguage } = useSelector((state) => state.language);
  
  // بيانات الشركة الكاملة
  const companyData = {
    // العنوان الرئيسي
    mainTitle: {
      en: "About Sanad Insurance",
      ar: "عن شركة سند للتأمين"
    },
    
    // وصف الشركة
    companyDescription: {
      ar: `شركة سند للتأمين
شركة مساهمة ليبية وهي إحدى الشركات الرائدة في ليبيا بنظام خدمات تأمينية طموح ومميز وبكوادر بشرية ذوي كفاءة عالية وخبرة مهنية تقارب الأربعين عاماً.

تأسست "سند للتأمين" في عام 2026 برأس مال قدره 10,000,000 دينار ليبي بقرار تأسيس رقم 6 لسنة 2026 م الصادر من هيئة الإشراف والرقابة على التأمين.

سند للتأمين .. اختيارك الأكثر أماناً.`,
      en: `Sanad Insurance
A Libyan joint stock company and one of the leading companies in Libya with an ambitious and distinguished system of insurance services, with highly efficient human cadres and professional experience approaching forty years.

"Sanad Insurance" was founded in 2026 with a capital of 10,000,000 Libyan dinars by establishment decision No. 6 of 2026 issued by the Insurance Supervision and Control Authority.

Sanad Insurance... Your safest choice.`
    },
    
    // رؤيتنا
    vision: {
      title: {
        en: "Our Vision",
        ar: "رؤيتنا"
      },
      description: {
        ar: `بناء نموذج أعمال مستدام لخدمة قاعدة عملائنا المتنامية تجارياً وتكافلياً وذلك بتوفير منصة تأمين مبتكرة من خلال الشراكة الإستراتيجية مع كبرى شركات إعادة التأمين العالمية وبتصنيف ائتماني (A) من وكالة AM Best Rating ووكالة Standard and Poors (S&P) إلى جانب خطط الاستثمار والتوسع لأنشطة التأمين في المنطقة بتقديم أعلى مستويات جودة الخدمة لعملائنا لإضفاء المزيد من الراحة والأمان على حياتهم.`,
        en: `Building a sustainable business model to serve our growing customer base commercially and mutually by providing an innovative insurance platform through strategic partnership with major global reinsurance companies with a credit rating (A) from AM Best Rating and Standard and Poors (S&P) agencies, along with investment plans and expansion of insurance activities in the region by providing the highest levels of service quality to our customers to add more comfort and safety to their lives.`
      }
    },
    
    // أهدافنا
    objectives: {
      title: {
        en: "Our Objectives",
        ar: "أهدافنا"
      },
      items: [
        {
          ar: 'منح عملائنا تغطيات تأمينية متطورة وشاملة بالإضافة إلى نشر الوعي التأميني بين الجمهور والمنافسة الشريفة القائمة على تحسين مستوى الخدمة والأداء.',
          en: 'Grant our customers advanced and comprehensive insurance coverage in addition to spreading insurance awareness among the public and fair competition based on improving the level of service and performance.'
        },
        {
          ar: 'التعامل مع المؤمن لهم بشفافية ونزاهة عالية والوفاء بالتزاماتهم المالية والقانونية وفقاً للشروط والأستثناءات التي تقدمها شركة "سند للتأمين" ووفقاً لأحكام القانون الليبي.',
          en: 'Dealing with the insured with high transparency and integrity and fulfilling their financial and legal obligations in accordance with the terms and exceptions provided by "Sanad Insurance" and in accordance with the provisions of Libyan law.'
        },
        {
          ar: 'توفير خدمات إلكترونية متطورة من خلال التطبيقات الهاتفية والمواقع الإلكترونية في إصدار الوثائق التأمينية وإعادة تجديدها بما يوفر اختصار للوقت والجهد لعملائنا.',
          en: 'Providing advanced electronic services through mobile applications and websites in issuing and renewing insurance documents, which saves time and effort for our customers.'
        },
        {
          ar: 'التوسع في دائرة الشراكات الإستراتيجية مع كبرى شركات إعادة التأمين العالمية لتوفير تغطية تأمينية أوسع للمؤمن لهم.',
          en: 'Expanding the circle of strategic partnerships with major global reinsurance companies to provide broader insurance coverage for the insured.'
        }
      ]
    },
    
    // القطاعات المستهدفة
    targetSectors: {
      title: {
        en: "Target Sectors",
        ar: "القطاعات المستهدفة"
      },
      items: [
        { en: "Airlines", ar: "شركات الطيران" },
        { en: "Real Estate & Construction Companies", ar: "الشركات العقارية والإنشائية" },
        { en: "Educational Institutions", ar: "المؤسسات التعليمية" },
        { en: "Factories of Various Production Lines", ar: "المصانع بمختلف خطوط إنتاجها" },
        { en: "Transport & Shipping Companies", ar: "شركات النقل والشحن" },
        { en: "Oil, Gas & Renewable Energy Companies", ar: "شركات النفط والغاز والطاقة المتجددة" },
        { en: "Commercial Companies in Various Specialties", ar: "الشركات التجارية بمختلف مجال تخصصها" }
      ]
    },
    
    // قصتنا (Story)
    ourStory: {
      title: {
        en: "Our Story",
        ar: "قصتنا"
      },
      content: {
        en: `Founded in 2026, our company was established to deliver innovative Takaful insurance solutions driven by technology, efficiency, and a commitment to excellence. The company emerged in response to the growing need in the Libyan market for modern insurance offerings that combine Takaful principles with advanced digital capabilities. We are officially registered with the Libyan Insurance Supervisory Authority.

Through the Sanad Insurance App, we provide customers with a fully digital experience that allows them to manage their policies, submit claims, track requests, and access insurance support with ease and transparency. The app serves as a modern gateway that reflects our vision of making insurance simpler, faster, and more accessible.

Our name "Sanad" (meaning "support" or "backing") reflects our commitment to being a reliable support system for our clients during uncertain times. We believe that insurance should not be complicated or intimidating – it should be a straightforward partnership based on trust and mutual understanding.

We are committed to developing Sharia compliant insurance solutions built on trust, clarity, and exceptional customer service. Operating in full compliance with Libyan regulatory requirements, we strive to deliver real value through flexible products, streamlined processes, and an advanced digital experience.`,
        ar: `تأسست شركتنا عام 2026 بهدف تقديم مقترحات تأمينية تكافلية مبتكرة تعتمد على التقنية والتميز في تصميم الحلول والخدمات. وجاء تأسيس الشركة استجابةً لحاجة السوق الليبية إلى منتجات تأمينية عصرية تجمع بين مبادئ التكافل والابتكار الرقمي. نحن مسجلون رسميًا لدى هيئة الإشراف على التأمين.

ومن خلال تطبيق سند للتأمين، نتيح لعملائنا تجربة رقمية متكاملة تُمكّنهم من إدارة وثائقهم، تقديم المطالبات، متابعة حالة الطلبات، والحصول على الاستشارات التأمينية بكل سهولة وشفافية. يمثل التطبيق بوابة حديثة تعكس رؤيتنا في جعل التأمين أكثر بساطة، سرعة، ووضوحًا.

يعكس اسمنا "سند" (بمعنى "دعم" أو "مساندة") التزامنا بأن نكون نظام دعم موثوقًا لعملائنا خلال الأوقات غير المؤكدة. نحن نؤمن بأن التأمين لا ينبغي أن يكون معقدًا أو مخيفًا – يجب أن يكون شراكة مباشرة تقوم على الثقة والتفاهم المتبادل.

نلتزم بتطوير حلول تأمينية متوافقة مع أحكام الشريعة الإسلامية، مع التركيز على بناء علاقة شراكة تقوم على الثقة، الوضوح، وخدمة العملاء عالية الجودة. كما نعمل وفق المتطلبات التنظيمية المعتمدة في ليبيا، ونحرص على تقديم قيمة مضافة حقيقية من خلال منتجات مرنة، إجراءات مبسّطة، وتجربة رقمية متقدمة.`
      }
    },
    
    // القيم الأساسية
    coreValues: {
      title: {
        en: "Our Core Values",
        ar: "قيمنا الأساسية"
      },
      items: [
        {
          icon: "🤝",
          title: {
            en: "Integrity",
            ar: "النزاهة"
          },
          description: {
            en: "We operate with honesty and transparency in all our dealings.",
            ar: "نعمل بصدق وشفافية في جميع تعاملاتنا."
          }
        },
        {
          icon: "🛡️",
          title: {
            en: "Trust",
            ar: "الثقة"
          },
          description: {
            en: "We build lasting relationships based on reliability and commitment.",
            ar: "نبني علاقات دائمة قائمة على الموثوقية والالتزام."
          }
        },
        {
          icon: "💡",
          title: {
            en: "Innovation",
            ar: "الابتكار"
          },
          description: {
            en: "We continuously improve our services through technology and creativity.",
            ar: "نحسن خدماتنا باستمرار من خلال التكنولوجيا والإبداع."
          }
        },
        {
          icon: "👥",
          title: {
            en: "Customer Focus",
            ar: "التركيز على العميل"
          },
          description: {
            en: "We prioritize our customers' needs and exceed their expectations.",
            ar: "نركز على احتياجات عملائنا ونفوق توقعاتهم."
          }
        },
        {
          icon: "⚖️",
          title: {
            en: "Compliance",
            ar: "الالتزام"
          },
          description: {
            en: "We strictly adhere to Sharia principles and regulatory requirements.",
            ar: "نلتزم بدقة بمبادئ الشريعة والمتطلبات التنظيمية."
          }
        },
        {
          icon: "🤲",
          title: {
            en: "Takaful",
            ar: "التكافل"
          },
          description: {
            en: "We believe in mutual cooperation and shared responsibility.",
            ar: "نؤمن بالتعاون المتبادل والمسؤولية المشتركة."
          }
        }
      ]
    },
    
    // إحصائيات
    stats: [
      {
        number: "10M+",
        label: {
          en: "Capital (LYD)",
          ar: "رأس المال (دينار)"
        }
      },
      {
        number: "13+",
        label: {
          en: "Insurance Types",
          ar: "نوع تأمين"
        }
      },
      {
        number: "40+",
        label: {
          en: "Years of Experience",
          ar: "سنة خبرة"
        }
      },
      {
        number: "A",
        label: {
          en: "Credit Rating",
          ar: "تصنيف ائتماني"
        }
      }
    ]
  };

  return (
    <div className="about-page">
      <Header />
      
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1 className="hero-title">
              {companyData.mainTitle[currentLanguage]}
            </h1>
            <p className="hero-subtitle">
              {currentLanguage === 'en' 
                ? 'Your trusted partner in protection and peace of mind' 
                : 'شريكك الموثوق في الحماية وراحة البال'}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Company Description */}
      <section className="company-description">
        <div className="container">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="description-content"
          >
            <div className="description-text">
              <h2 className="section-title">
                {currentLanguage === 'en' ? 'Who We Are' : 'من نحن'}
              </h2>
              <p className="description-paragraph">
                {companyData.companyDescription[currentLanguage]}
              </p>
            </div>
            
            <motion.div 
              className="stats-grid"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {companyData.stats.map((stat, index) => (
                <div key={index} className="stat-card">
                  <h3 className="stat-number">{stat.number}</h3>
                  <p className="stat-label">{stat.label[currentLanguage]}</p>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="vision-content"
          >
            <div className="vision-icon">👁️</div>
            <h2 className="section-title">{companyData.vision.title[currentLanguage]}</h2>
            <p className="vision-text">
              {companyData.vision.description[currentLanguage]}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Objectives Section */}
      <section className="objectives-section">
        <div className="container">
          <h2 className="section-title">{companyData.objectives.title[currentLanguage]}</h2>
          
          <div className="objectives-grid">
            {companyData.objectives.items.map((objective, index) => (
              <motion.div
                key={index}
                className="objective-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="objective-number">{index + 1}</div>
                <p className="objective-text">{objective[currentLanguage]}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Target Sectors */}
      <section className="sectors-section">
        <div className="container">
          <h2 className="section-title">{companyData.targetSectors.title[currentLanguage]}</h2>
          
          <div className="sectors-grid">
            {companyData.targetSectors.items.map((sector, index) => (
              <motion.div
                key={index}
                className="sector-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <span className="sector-icon">🏢</span>
                <p className="sector-name">{sector[currentLanguage]}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="story-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="story-content"
          >
            <h2 className="section-title">{companyData.ourStory.title[currentLanguage]}</h2>
            <div className="story-text">
              {companyData.ourStory.content[currentLanguage].split('\n\n').map((paragraph, index) => (
                <p key={index} className="story-paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Core Values */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">{companyData.coreValues.title[currentLanguage]}</h2>
          
          <div className="values-grid">
            {companyData.coreValues.items.map((value, index) => (
              <motion.div
                key={index}
                className="value-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title[currentLanguage]}</h3>
                <p className="value-description">{value.description[currentLanguage]}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="cta-content"
          >
            <h2 className="cta-title">
              {currentLanguage === 'en' 
                ? 'Join Our Journey of Protection' 
                : 'انضم إلى رحلتنا في الحماية'}
            </h2>
            <p className="cta-text">
              {currentLanguage === 'en' 
                ? 'Be part of a new era in Libyan insurance. Experience protection you can trust.' 
                : 'كن جزءًا من عصر جديد في التأمين الليبي. جرب حماية يمكنك الوثوق بها.'}
            </p>
            <div className="cta-buttons">
              <motion.button
                className="cta-button primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.location.href = '/contact'}
              >
                {currentLanguage === 'en' ? 'Contact Us' : 'تواصل معنا'}
              </motion.button>
              <motion.button
                className="cta-button secondary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.location.href = '/services'}
              >
                {currentLanguage === 'en' ? 'View Services' : 'عرض الخدمات'}
              </motion.button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;